import type { EmissorConfigType } from 'types';
import { env } from 'utils/env';

export const JVCEF: EmissorConfigType = {
  social: 'CAIXA Cartões Pré-Pagos S.A.',
  logo: `${env.REACT_APP_ASSETS_PORTAL}/jvcef/img/logoFooter.png`,
  infoList: [
    {
      code: 'cnpj',
      text: 'CNPJ: 39.459.331/0001-20',
      link: null,
    },
    {
      code: 'aviso-privacidade',
      text: `Aviso de Privacidade`,
      link: 'https://www.caixaprepagos.com.br/aviso-de-privacidade.html',
    },
  ],
  portal: {},
  fonts: `${env.REACT_APP_ASSETS_PORTAL}/jvcef/css/fonts.min.css`,
};
